/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConversationStatus {
    OPEN = 'open',
    CLOSED = 'closed',
}
